import { supabase } from "../supabase";

const SitesAPI = {
  async getSiteInfo(siteID: string) {
    return supabase.from("site").select("*").eq("site_id", siteID).single()
  },
}
export default SitesAPI
